import(/* webpackMode: "eager" */ "/app/apps/web/app/cart/page.tsx");
